import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function SvvSpinner(): JSX.Element {
  const { t } = useTranslation('repairshop')
  return (
    <Box
      data-testid={'svv-no-label-loading-spinner'}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: 20,
      }}
    >
      <CircularProgress
        size={50}
        thickness={1.5}
        style={{ color: 'primary.main', background: 'transparent' }}
        aria-label={`${t('common.loading')}`}
      />
    </Box>
  )
}
